<div id="message-container" *ngIf="messages.length > 0">
  <ngb-alert *ngFor="let message of messages" [type]="toBootstrapSeverity(message)" (close)="removeMessage(message)">
    {{ message.message }}
  </ngb-alert>
</div>
